import { CountryEntry } from './CountryEntry';

export const countriesEs: CountryEntry[] = [
  {
    name: 'Alemania',
    code: 'DE'
  },
  {
    name: 'Austria',
    code: 'AT'
  },
  {
    name: 'Bélgica',
    code: 'BE'
  },
  {
    name: 'Bulgaria',
    code: 'BG'
  },
  {
    name: 'Chipre',
    code: 'CY'
  },
  {
    name: 'Croacia',
    code: 'HR'
  },
  {
    name: 'Dinamarca',
    code: 'DK'
  },
  {
    name: 'Eslovaquia',
    code: 'SK'
  },
  {
    name: 'Eslovenia',
    code: 'SI'
  },
  {
    name: 'España',
    code: 'ES'
  },
  {
    name: 'Estonia',
    code: 'EE'
  },
  {
    name: 'Finlandia',
    code: 'FI'
  },
  {
    name: 'Francia',
    code: 'FR'
  },
  {
    name: 'Grecia',
    code: 'GR'
  },
  {
    name: 'Hungría',
    code: 'HU'
  },
  {
    name: 'Irlanda',
    code: 'IE'
  },
  {
    name: 'Islandia',
    code: 'IS'
  },
  {
    name: 'Italia',
    code: 'IT'
  },
  {
    name: 'Letonia',
    code: 'LV'
  },
  {
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    name: 'Lituania',
    code: 'LT'
  },
  {
    name: 'Luxemburgo',
    code: 'LU'
  },
  {
    name: 'Malta',
    code: 'MT'
  },
  {
    name: 'Noruega',
    code: 'NO'
  },
  {
    name: 'Países Bajos',
    code: 'NL'
  },
  {
    name: 'Polonia',
    code: 'PL'
  },
  {
    name: 'Portugal',
    code: 'PT'
  },
  {
    name: 'Reino Unido',
    code: 'GB'
  },
  {
    name: 'República Checa',
    code: 'CZ'
  },
  {
    name: 'Rumanía',
    code: 'RO'
  },
  {
    name: 'Suecia',
    code: 'SE'
  },
  {
    name: 'Suiza',
    code: 'CH'
  }
];
